import Footer from "../../components/Footer";
import getCoreUIStore from "../../stores/core/core-ui-store";
import { TET3PageDiv } from "../../TypesNEW";
import ET3Div from "../et3-div";
import { withLiteObserverAndTheme } from "../et3-enhanced-render";

const ET3PageDiv = withLiteObserverAndTheme<TET3PageDiv>((props) => {
  const { children, alignItems, fDirection, style, theme } = props;
  const { colors } = theme;
  const sideBarVisible = getCoreUIStore().shouldShowSideBar.get();
  const mainWidth = sideBarVisible ? 1620 : 1920;
  const pageWidth = sideBarVisible ? 1580 : 1880;

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      withShadow={false}
      width={mainWidth}
      height={1110}
      fDirection={"row"}
      alignItems={"flex-start"}
      justifyContent="flex-end"
      color={colors.all.transparent}
      style={{}}
      onClick={() => {}}
    >
      <ET3Div
        isScrollable={false}
        isExtendable={true}
        withShadow={false}
        width={pageWidth}
        height={0}
        fDirection={fDirection}
        alignItems={alignItems}
        justifyContent="flex-start"
        color={colors.all.transparent}
        style={style}
        onClick={() => {}}
      >
        <ET3Div
          isScrollable={false}
          isExtendable={true}
          withShadow={false}
          width={pageWidth}
          height={1020}
          fDirection={fDirection}
          alignItems={alignItems}
          justifyContent="flex-start"
          color={colors.all.transparent}
          style={style}
          onClick={() => {}}
        >
          {children}
        </ET3Div>
        <Footer />
      </ET3Div>
    </ET3Div>
  );
});
export default ET3PageDiv;
